import { css } from 'styled-components';

export default css`
  td {
    padding: 3px;
    border: solid 1px #333;
  }
`;
